import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "report-subject-mapping",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "admin-gradebooksync" */ "./ReportSubjectMapping"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
